import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';

import { Observable, from, of, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-order-approvers',
  templateUrl: './order-approvers.component.html',
  styleUrls: ['./order-approvers.component.css']
})
export class OrderApproversComponent extends BaseCrudComponent {
    translations: any;
    approvers: any;
    sellers: any;
    loading = false;

    curr_approver:any;
    curr_sellers:any;
  
    constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService
    ) {
        super(srv, modalService, storage, router);

        this.approvers = [];
        this.sellers = [];
        this.loading = true;
    }

    ngOnInit() {
        this.translate.getTranslation(this.translate.currentLang)
            .subscribe((translations) => {
                this.translations = translations;
                super.ngOnInit();

                this.loading = true;
                this.getApprovers().subscribe(d => {
                    //console.dir(d);
                    this.loading = false;
                    if (d != false) {
                        this.approvers = d;
                    }
                });
            });
    }

    public getApprovers() {
        var par_url = 'User/All';
        return this.srv.getCall(par_url).pipe(
            mergeMap(x => {
                let mydata: any = { status: false, message: '', data: [] };
                mydata = x;

                if (mydata.status == true) {
                    return of(mydata.data);
                }
                else {
                    return of(false);
                }
            }),
            //timeout(MAX_TIME),
            catchError(data => of(false))
        );
    }

    public getSellers(id:any) {
        var par_url = 'Portal/ApproveAgent/Get';

        let to:any = {
            userId: id
        };

        return this.srv.postCall(par_url, to).pipe(
            mergeMap(x => {
                let mydata: any = { status: false, message: '', data: [] };
                mydata = x;

                if (mydata.status == true) {
                    return of(mydata.data);
                }
                else {
                    return of(false);
                }
            }),
            //timeout(MAX_TIME),
            catchError(data => of(false))
        );
    }

    showSellers(ev:any){
        //console.dir(ev);
        if( ev.value != undefined ){
            let id = ev.value.id;
            this.curr_sellers = [];
            this.sellers = [];
            this.loading = true;

            this.getSellers(id).subscribe(d => {
                //console.dir(d);
                this.loading = false;
                if (d != false) {
                    this.sellers = d['approversDetails'];

                    this.sellers.forEach(x => {
                        if( x.check ){
                            this.curr_sellers.push(x);
                        }
                    });
                }
            });
        }
    }

    updateSellers(){
        // console.dir(this.curr_approver);
        // console.dir(this.curr_sellers);

        if( this.curr_approver && (Array.isArray(this.curr_sellers)) && (this.curr_sellers.length > 0) ){
            var to: any;
            to = {};
            to.userId = this.curr_approver['id'];
            to.approversDetails = [];

            this.curr_sellers.forEach(s => {
                to.approversDetails.push({agentCode: s.agentCode});
            });

            var qst = 'Portal/ApproveAgent/Save';
            this.isUpdating = true;

            this.srv.postCall(qst, to).subscribe(x => {
                this.isUpdating = false;
                if (x.status) {
                    Swal.fire('Actualizado', '', 'success');
                }//end success
                else {
                    Swal.fire(x.message, '', 'error');
                }
            });
        }
    }
    
}
